import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, PhoneOff } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchBlockedRanges, GEO_STR as S, type BlockedRangeRow } from './geoApi'

/**
 * A11.12 — Bloklangan raqam diapazonlari. Bloklangan prefiks/MSISDN oraliqlari
 * (raqam-fabrikasi/spam). Greenfield `/admin/geo/blocked-ranges` → fetcher
 * fail-soft bo'sh; backend chiqqanda to'ladi.
 */
export function BlockedRangesScreen() {
  const columns = useMemo<AdminColumn<BlockedRangeRow>[]>(
    () => [
      { key: 'country_code', header: S.code, type: 'id', width: 80 },
      {
        key: 'prefix',
        header: S.prefix,
        type: 'text',
        minWidth: 160,
        render: (r) => <span className="font-mono tabular text-primary">{r.prefix}</span>,
      },
      { key: 'reason', header: S.reason, type: 'longtext', minWidth: 200 },
      { key: 'blocked_at', header: S.blockedAt, type: 'date', width: 150 },
    ],
    [],
  )

  const fetcher = useCallback(fetchBlockedRanges, [])

  return (
    <>
      <PageHeader
        title={S.rangesTitle}
        screenId="A11.12"
        description={S.rangesNote}
        actions={
          <Link
            to="/geo"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {S.backToList}
          </Link>
        }
      />
      <DataTable<BlockedRangeRow>
        screenId="A11.12"
        permission={PERMISSIONS.COUNTRIES_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <PhoneOff size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
